import * as StyleFunctions from '../utilities/StyleFunctions';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as CoreFns from '../utilities/CoreFns';
import * as NamingFns from '../utilities/NamingFns';

export function createSpecificEntity(entityType, id, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, tableInfo, upwardInfo, onClickItemChangeSelection, screenPath, interactionFn, organicChanges){


      var ele = document.createElement(entityType);
      var entityStore = CoreFns.goDownPath(currentList, ['as'], 0);
      ele.id = id;
      if (!entityStore[id]){
        var p = CoreFns.goDownPath(currentList, screenPath);
        console.log(p);
        console.log(screenPath);
        console.log(currentList);
        console.log(entityStore);
        console.log(id);


        var itemLoc = ['as', id];
        var yHere = {n:'1', s:{text:ResponsiveFns.msg('Hello')}, oc:{}, t:'SPAN'};
        yHere._na = id.substr(id.length - 3);
        var changes2 = [{t:'w',w:itemLoc,n:yHere}];
        organicChanges(changes2);

        return ele;
      }

      var thisPath = ['as', id];
//
      var relevantEntity = entityStore[id].s;
      var s = StyleFunctions.evaluateStyleR(entityType, relevantEntity, thisPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, {}, ownVariables, urlParamsForExecution, urlHeader, chains);
      if (entityType === 'SPAN'){
        var txtF = NamingFns.getTextOfASpace(relevantEntity.text, currentList, {t:'Text String'});
        var txt;
        if (txtF.t){
          txt = txtF.t;
        }else{
          txt = txtF;
        }
        if (txt.length > 10){
          txt = txt.substr(0, 10) + "...";
        }

        var e2 = document.createTextNode(txt);
        e2.contentEditable = false;
        if (s.B){
          var e5 = document.createElement('B');
          e5.appendChild(e2);
          e2 = e5;
        }
        if (s.U){
          var e7 = document.createElement('U');
          e7.appendChild(e2);
          e2 = e7;
        }
        if (s.I){
          var e6 = document.createElement('I');
          e6.appendChild(e2);
          e2 = e6;
        }
        if (!interactionFn){
          ele.className = 'preEditing';
        }
        ele.onmouseover = function(e){
          e.stopPropagation();
        }
        ele.contentEditable = false;
        onClickItemChangeSelection(ele, screenPath);
        ele.appendChild(e2);
      }
      var keys = Object.keys(s);
      keys.forEach((aKey, index)=>{
        ele.style[aKey] = s[aKey];
      })
      return ele;      
}

export default function elementCreator(n, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, upwardInfo, onClickItemChangeSelection, screenPath, interactionFn, organicChanges){
  return createElementReal(n, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, {}, upwardInfo, onClickItemChangeSelection, screenPath, interactionFn, organicChanges);
}

function gElement(){
    var ele = document.createElement('TD');
    ele.id = '_g';
    ele.onclick = function(e){
      window.alert('Edit left cell');
    }
    ele.contentEditable = false;
    // ele.style.padding = '10px';
    // ele.style.backgroundColor = '#00FF00';
    // ele.style.border = '1px dashed #CCCCCC'
    return ele;
}

function flattenV(v){
  return v.map((aV, index)=>{
    return aV.u;
  }).join('');
}

function createElementReal(n, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, tablePassThrough, upwardInfo, onClickItemChangeSelection, screenPath, interactionFn, organicChanges){
  if (n.t === 't'){
    return createAPaddedNode(n.v,n.s,width, height);
  }else if (n.t === 'tb'){
    return createAPaddedNode(flattenV(n.v),n.s,width, height);
  }else if (n.t === 'br'){
    return document.createElement('br');
  }else if (n.t === 'a'){
    if (n.i === '_g'){
      return gElement();
    }else{
      return createSpecificEntity(n.n, n.i, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, tablePassThrough, upwardInfo, onClickItemChangeSelection, screenPath, interactionFn, organicChanges)
    }

  }else{
    var title;
    if (n.t === 'h'){title = n.n};
    if (n.t === 'd'){title = 'div'}
    var newInput = document.createElement(title);
    for (var i = 0; i < n.v.length; i++){
      var anE = createElementReal(n.v[i], currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, tablePassThrough, upwardInfo, onClickItemChangeSelection, screenPath, interactionFn, organicChanges);
      newInput.appendChild(anE);
    }
    return newInput;
  }

}

function createAPaddedNode(text, style, width, height){
    var textNode = document.createTextNode(text);
    var keys = Object.keys(style);
    keys.forEach((aKey, index)=>{
      var k;
        if (aKey === 'B' || aKey === 'U' || aKey === 'I'){
          k = document.createElement(aKey);
          k.appendChild(textNode);
          textNode = k;
        }else if (aKey === 'C' || aKey === 'D' || aKey === 'F' || aKey === 'G'){
          k = document.createElement('span');
          if (aKey === 'C'){
            if (style.C.indexOf('linear-gradient') === 0){
              k.style.backgroundImage = style.C;
              k.className = 'gradientText';
            }else{
              k.style.color = style.C;
            }
          }else if (aKey === 'D'){
            k.style['background-color'] = style.D;
          }else if (aKey === 'F'){
            k.style['font-size'] = ResponsiveFns.convertFontSize(style.F, width, height);
            k.style['fontSizeP'] = style.F;
          }else if (aKey === 'G'){
            k.style['font-family'] = style.G;
          }
          k.appendChild(textNode);
          textNode = k;
        }
    });
    return textNode;
}


